import { createSelector } from 'reselect';

import { emptySlice } from 'modules/dealers/reducer/ui/select/stack';
import { getDealerDefaultLanguage } from 'selectors/dealerSelectors';

/**
 * @typedef {import('modules/dealers/reducer/ui/select').SelectState} State
 */

/**
 * Return given properties
 * @template U
 * @param {State} _
 * @param {U} props
 * @returns {U}
 */
const getProps = (_, props) => props;

/**
 * Return incriminate slice
 * @param {*} state
 * @returns {State}
 */
const getState = state => state.dealers.ui.select;

const getSelectsRoot = createSelector(getState, state => state.stack);

const getSelectByToken = createSelector(
  getSelectsRoot,
  getProps,
  (state, /** @type {string} */ token) => state[token] ?? emptySlice
);

export const getIds = createSelector(getSelectByToken, select => select.ids);

const getFilters = createSelector(getSelectByToken, select => select.filters);

export const isLoading = createSelector(getSelectByToken, select => select.isLoading);

export const getPage = createSelector(getSelectByToken, select => select.page);

export const hasNextPage = createSelector(getPage, page => page.number + 1 < page.totalPages);

export const getParams = createSelector(
  getPage,
  getFilters,
  getDealerDefaultLanguage,
  ({ size }, filters, language) => ({
    size,
    language,
    ...filters,
  })
);
